import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';

const StyledSpace = styled(Space)`
  flex-wrap: wrap;
  > * {
    margin-bottom: 0.5rem;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: 200px;
  }
`;

const StyledForm = styled(Form)`
  max-width: 100%;
`;

export interface ProfileOwnerFiltersFormModel {
  serialNumber?: string;
  assignedDevice?: boolean;
  modeType?: 'FAMILY_MODE' | 'PRO_MODE';
  status?: string;
  hasToken?: boolean;
  partnerName?: string;
}

export interface ProfileOwnerFiltersProps {
  loading?: boolean;
  value?: ProfileOwnerFiltersFormModel;
  onSubmit: FormikOnSubmit<ProfileOwnerFiltersFormModel>;
  style?: CSSProperties;
  partnerHardcoded?: string;
}

export const BusinessPartnersDevicesModalFilters: FC<ProfileOwnerFiltersProps> = ({
  onSubmit,
  loading,
  partnerHardcoded,
  value = {},
  style,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <StyledForm style={style} layout="inline">
        <StyledSpace>
          <Input
            name="serialNumber"
            placeholder={intlMessage({ id: 'deviceSerialNumber' })}
            style={{ minWidth: 150 }}
          />
          <SubpartnersFilterSelect
            name="partnerName"
            placeholder={intlMessage({ id: 'partner' })}
            style={{ minWidth: 150, width: '100%' }}
            value={partnerHardcoded}
            disabled={partnerHardcoded ? true : false}
          />

          <Space>
            <SubmitButton
              type="default"
              loading={loading}
              icon={<SearchOutlined />}
            >
              <FormattedMessage id="search" tagName="span" />
            </SubmitButton>
            <Button id="button-clear-devices-modal-filter" htmlType="reset">
              <FormattedMessage id="clear" />
            </Button>
          </Space>
        </StyledSpace>
      </StyledForm>
    </Formik>
  );
};
